<template>
  <div>
    <header>
    </header>
    <section class="YnaviContent">
      <div class="mainMenu">
      </div>
      <div class="subMenu">
      </div>
      <!-- 主内容区begin -->
      <div class="mainCon">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <!-- 主内容区end -->
    </section>
  </div>
</template>
<script>
export default {
  name: 'sk-layouts'
}
</script>
